
import './template.css'


export const ButterflyBorder = ({ }) => {
    return <div className="butterfly-border"></div>
}

export const ImageCollection = ({ photos }) => {
    return <div className='image-collection'>
        {photos.map((photo, i) => <img className='image-collection' key={i} src={photo.url} alt={photo.description} />)}
    </div>
}

export const SmallImageCollection = ({ photos }) => {
    return <div className='image-collection'>
        {photos.map((photo, i) => <img className='image-collection small' key={i} src={photo.url} alt={photo.description} />)}
    </div>
}